// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style__moduleItem___1HXhA{display:flex;padding-bottom:10}.style__moduleItemSwitch___2X76P{width:40px}\n", "",{"version":3,"sources":["webpack://./src/management/modules/style.scss"],"names":[],"mappings":"AAAA,2BACE,YAAa,CACb,iBAAkB,CACnB,iCAGC,UAAW","sourcesContent":[".moduleItem {\n  display: flex;\n  padding-bottom: 10;\n}\n\n.moduleItemSwitch {\n  width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"moduleItem": "style__moduleItem___1HXhA",
	"moduleItemSwitch": "style__moduleItemSwitch___2X76P"
};
export default ___CSS_LOADER_EXPORT___;
